import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
    addSecondHandBatteryType, editSecondHandBatteryType, removeSecondHandBatteryType, updateSecondHandBatteryType
} from '../../../actions/admin/actionAdminSecondHandBattery';
import {IconCancel, IconDelete, IconEdit, IconSave, PrimaryIcon} from '../../common/Button';
import {MessageCell, StyledSmall} from '../../common/StyledComponents';
import ConfirmationDialog from '../../common/modal/ConfirmationDialog';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class SecondHandBatteryRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            valueName: this.props.data.presetName,
            isOpenRemoveDialog: false
        };
    }

    onClickPencil = e => {
        const {adminSecondHandBatteryType, index, data, domain, updateSecondHandBatteryType, editSecondHandBatteryType} = this.props;
        const {valueName} = this.state;
        e.preventDefault();
        if ((adminSecondHandBatteryType.edit === index) && ((valueName !== data.presetName))) {
            const item = {
                group: data.group,
                uuid: data.uuid,
                presetName: valueName,
            };
            updateSecondHandBatteryType(domain, item);
        } else if (adminSecondHandBatteryType.edit === index) {
            editSecondHandBatteryType(-1);
        } else {
            this.setState({valueName: data.presetName});
            editSecondHandBatteryType(index);
        }
    };

    onCancel = e => {
        e.preventDefault();
        this.setState({valueName: this.props.data.presetName});
        this.props.editSecondHandBatteryType(-1);
    };

    onClickDelete = () => {
        const item = {
            group: this.props.data.group,
            uuid: this.props.data.uuid,
        };
        this.props.removeSecondHandBatteryType(this.props.domain, item);
    };

    onChangeHandlerName = e => {
        e.preventDefault();
        this.setState({valueName: e.target.value});
    };

    onChangeHandlerMessage = e => {
        e.preventDefault();
        this.setState({valueMessage: e.target.value});
    };

    showRemoveModal = () => {
        this.setState({
            isOpenRemoveDialog: true
        });
    };

    closeModal = e => {
        e.preventDefault();
        this.setState({
            isOpenRemoveDialog: false
        });
    };

    saveModal = e => {
        e.preventDefault();
        this.setState({
            isOpenRemoveDialog: false
        });
        this.onClickDelete();
    };

    renderHandler(provided) {
        return (
            <td className="col-1"
                {...provided.dragHandleProps}
            >
                {
                    (this.props.adminSecondHandBatteryType.edit === -1) &&
                    <FontAwesomeIcon icon="arrows-alt-v"/>
                }
            </td>
        );
    }

    renderName(index) {
        if (this.props.adminSecondHandBatteryType.edit === index) {
            return (
                <StyledSmall
                    className="form-control"
                    value={this.state.valueName}
                    placeholder="Enter your text here..."
                    onChange={this.onChangeHandlerName}/>
            );
        } else {
            return this.props.data.presetName;
        }
    }

    renderTools(index) {
        let buttons;

        if (this.props.adminSecondHandBatteryType.edit === index) {
            buttons =
                <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                    <div className="btn-group " role="group" aria-label="First group">
                        <PrimaryIcon className="btn btn-sm m-sm-1" onClick={this.onClickPencil}
                                     title="Save" type="button">
                            <IconSave/>
                        </PrimaryIcon>
                    </div>
                    <div className="btn-group " role="group" aria-label="Second group">
                        <PrimaryIcon className="btn btn-sm  m-sm-1" onClick={this.onCancel}
                                     title="Cancel" type="button">
                            <IconCancel/>
                        </PrimaryIcon>
                    </div>
                </div>
        } else {
            buttons =
                <div className="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                    <div className="btn-group " role="group" aria-label="First group">
                        <PrimaryIcon className="btn btn-sm m-sm-1" onClick={this.onClickPencil}
                                     title="Edit" type="button">
                            <IconEdit/>
                        </PrimaryIcon>
                    </div>
                    <div className="btn-group " role="group" aria-label="Second group">
                        <PrimaryIcon className="btn btn-sm m-sm-1" title="Delete" type="button"
                                     onClick={this.showRemoveModal}>
                            <IconDelete/>
                        </PrimaryIcon>
                    </div>
                </div>
        }

        return buttons;
    }

    render() {
        const {provided, index} = this.props;
        return (
            <tr className="d-flex"
                ref={provided.innerRef}
                {...provided.draggableProps}>
                {this.renderHandler(provided)}
                {console.log("index:", index)}
                <MessageCell className="col-9">{this.renderName(index)}</MessageCell>
                <td className="col-2">{this.renderTools(index)}</td>
                <ConfirmationDialog show={this.state.isOpenRemoveDialog} closeModal={this.closeModal}
                                    saveModal={this.saveModal} actionIdentifier="remove the automatic response"/>
            </tr>
        );
    }
}

SecondHandBatteryRow.propTypes = {
    data: PropTypes.object.isRequired,
    provided: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    adminSecondHandBatteryType: state.adminSecondHandBatteryType,
});

export default connect(mapStateToProps, {
    addSecondHandBatteryType,
    editSecondHandBatteryType,
    removeSecondHandBatteryType,
    updateSecondHandBatteryType
})(SecondHandBatteryRow);
